(() => {
  const DRAWER_ID = 'FJContactDrawer';
  const PHONE = '+13472024976';
  const DISPLAY_PHONE = '+1 (347) 202-4976';
  let lastFocused = null;

  function icon(name) {
    const icons = {
      phone: '<path d="M6.62 10.79a15.46 15.46 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.14.38 2.34.57 3.56.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A18 18 0 0 1 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.22.19 2.42.57 3.56a1 1 0 0 1-.24 1.02l-2.21 2.21Z"/>',
      calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>',
      whatsapp: '<path d="M20.5 11.7a8.5 8.5 0 0 1-12.6 7.45L3 20.5l1.35-4.75A8.5 8.5 0 1 1 20.5 11.7Z"/><path d="M8.4 7.8c.25-.55.52-.56.77-.57h.66c.2 0 .43.08.55.36l.76 1.82c.08.2.04.36-.08.53l-.58.74c-.12.14-.22.3-.1.5.42.7 1.04 1.44 1.83 2 .2.14.36.12.52-.05l.8-.92c.16-.18.34-.22.55-.13l1.9.9c.22.1.36.25.38.44.04.47-.18 1.45-.93 1.95-.48.32-1.12.56-2.04.36-1.55-.33-3.6-1.63-4.88-3.38-1.06-1.44-1.9-3.2-1.5-4.32.1-.28.2-.43.39-.67Z"/>',
      mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/>',
      truck: '<path d="M3 6h11v9H3zM14 9h3.5L21 12.5V15h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>'
    };
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icons[name]}</svg>`;
  }

  function chevron() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
  }

  function row({ href, iconName, title, subtitle, external = false }) {
    const externalAttributes = external ? ' target="_blank" rel="noopener noreferrer"' : '';
    return `
      <a class="fj-contact-drawer__row" href="${href}"${externalAttributes}>
        <span class="fj-contact-drawer__row-icon">${icon(iconName)}</span>
        <span class="fj-contact-drawer__row-copy">
          <span class="fj-contact-drawer__row-title">${title}</span>
          <span class="fj-contact-drawer__row-subtitle">${subtitle}</span>
        </span>
        <span class="fj-contact-drawer__chevron">${chevron()}</span>
      </a>`;
  }

  function drawerMarkup() {
    return `
      <div class="fj-contact-drawer" id="${DRAWER_ID}" aria-hidden="true">
        <button class="fj-contact-drawer__backdrop" type="button" data-fj-contact-close aria-label="Close contact panel"></button>
        <aside class="fj-contact-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="FJContactDrawerTitle" tabindex="-1">
          <div class="fj-contact-drawer__header">
            <h2 class="fj-contact-drawer__title" id="FJContactDrawerTitle">Contact Us</h2>
            <button class="fj-contact-drawer__close" type="button" data-fj-contact-close aria-label="Close">×</button>
          </div>

          <div class="fj-contact-drawer__media">
            <img src="https://cdn.shopify.com/s/files/1/0490/8829/9172/files/WhatsApp_Image_2026-04-29_at_8.22.42_PM.jpg?v=1777508599" alt="Fantastic Jewelry NYC showroom in the Diamond District" loading="lazy">
          </div>

          <p class="fj-contact-drawer__intro">Need help choosing real 10K/14K gold, checking a size, or planning a showroom visit? Our team is here to help.</p>

          <nav class="fj-contact-drawer__links" aria-label="Contact options">
            ${row({ href: `tel:${PHONE}`, iconName: 'phone', title: 'Call / Text Us', subtitle: DISPLAY_PHONE })}
            ${row({ href: '/pages/contact', iconName: 'calendar', title: 'Plan a Showroom Visit', subtitle: '20 W 47th St, MZ 12 · Mon–Fri 12:00–5:30 PM' })}
            ${row({ href: 'https://wa.me/13472024976?text=Hi%20Fantastic%20Jewelry%20NYC%2C%20I%20need%20help%20choosing%20a%20piece.', iconName: 'whatsapp', title: 'Message on WhatsApp', subtitle: 'Product questions and bilingual support', external: true })}
            ${row({ href: 'mailto:info@fantasticjewelrynyc.com', iconName: 'mail', title: 'Email Us', subtitle: 'info@fantasticjewelrynyc.com' })}
            ${row({ href: '/apps/parcelpanel', iconName: 'truck', title: 'Track My Order', subtitle: 'View the latest FedEx shipping status' })}
          </nav>

          <p class="fj-contact-drawer__note">Support helps you choose. Orders are completed securely on fantasticjewelrynyc.com.</p>
        </aside>
      </div>`;
  }

  function ensureDrawer() {
    let drawer = document.getElementById(DRAWER_ID);
    if (!drawer) {
      document.body.insertAdjacentHTML('beforeend', drawerMarkup());
      drawer = document.getElementById(DRAWER_ID);
    }
    return drawer;
  }

  function triggers() {
    return Array.from(document.querySelectorAll('[data-fj-contact-trigger]'));
  }

  function setTriggerState(isOpen) {
    triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', String(isOpen)));
  }

  function openDrawer(trigger) {
    const drawer = ensureDrawer();
    if (!drawer) return;

    lastFocused = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fj-contact-drawer-open');
    setTriggerState(true);

    window.setTimeout(() => {
      drawer.querySelector('.fj-contact-drawer__close')?.focus();
    }, 30);
  }

  function closeDrawer() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fj-contact-drawer-open');
    setTriggerState(false);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function trapFocus(event) {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer?.classList.contains('is-open') || event.key !== 'Tab') return;

    const focusable = Array.from(
      drawer.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
    ).filter((element) => element.offsetParent !== null);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function init() {
    ensureDrawer();
    triggers().forEach((trigger) => {
      trigger.setAttribute('aria-controls', DRAWER_ID);
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fj-contact-trigger]');
    if (trigger) {
      event.preventDefault();
      openDrawer(trigger);
      return;
    }

    if (event.target.closest('[data-fj-contact-close]')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
    trapFocus(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
